<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="업종코드 관리" device="web">
        <template v-slot:body>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" lg="12" class="pa-0">
                <DxDataGrid
                  id="typeOfBusinessDataGrid"
                  class="layout-col-height00"
                  width="100%"
                  :ref="dxDataGridRef"
                  :data-source="datasource"
                  :remote-operations="false"
                  :hover-state-enabled="true"
                  :allow-column-resizing="true"
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true"
                  :column-auto-width="true"
                  :show-borders="true"
                  :show-row-lines="true"
                  :focused-row-enabled="true"
                  @editor-preparing="onEditorPreparing"
                  key-expr="id"
                >
                  <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

                  <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

                  <DxColumn
                    data-field="detailCd"
                    caption="세세분류 코드"
                    css-class="devest-grid-header-require"
                    data-type="string"
                    alignment="left"
                  />
                  <DxColumn data-field="detailNm" caption="세세분류 명" css-class="devest-grid-header-require" data-type="string" alignment="left" />
                  <DxColumn data-field="majorCd" caption="대분류 코드" css-class="devest-grid-header-require" data-type="string" alignment="left" />
                  <DxColumn data-field="majorNm" caption="대분류 명" css-class="devest-grid-header-require" data-type="string" alignment="left" />
                  <DxColumn data-field="middleCd" caption="중분류 코드" data-type="string" alignment="left" />
                  <DxColumn data-field="middleNm" caption="중분류 명" data-type="string" alignment="left" />
                  <DxColumn data-field="subCd" caption="소분류 코드" data-type="string" alignment="left" />
                  <DxColumn data-field="subNm" caption="소분류 명" data-type="string" alignment="left" />
                </DxDataGrid>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <i-card-right
        :useBtnList="buttonUseList"
        :reportItems="reportItems"
        @btnSearch="btnSearch(true)"
        @btnSave="btnSave"
        @btnUpload="btnUpload"
        @btnDownload="btnDownload"
        @btnPrint="btnPrint"
      >
      </i-card-right>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { Workbook } from 'exceljs'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { saveAs } from 'file-saver-es'
import { exportDataGrid as exportExcel } from 'devextreme/excel_exporter'
import { exportDataGrid as exportPdf } from 'devextreme/pdf_exporter'
import malgun from '@/assets/font/malgun.ttf'

import { getTypes, saveTypes, getTypeForm, uploadForms } from '@/api/setting/typeOfBusinessManage.js'
import { downloadFile } from '@/api/baseManage/fileUpload'

export default {
  mixins: [baseview, BaseDataGrid],
  name: 'TypeOfBusinessManage',
  components: {},
  data() {
    return {
      dxDataGridRef: 'typeOfBusinessDataGrid',
      datasource: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnSave', //저장
        'btnDownload', //다운로드
        'btnUpload', //업로드
        'btnPrint' //출력
      ],
      reportItems: [
        { role: 'pdf', title: 'PDF' },
        { role: 'xls', title: 'EXCEL' }
      ],
      allMode: 'allPages'
    }
  },
  mounted() {
    this.btnSearch(true)
  },
  methods: {
    // 조회 버튼
    btnSearch(isNotify) {
      this.openLoading('searching')
      getTypes(isNotify)
        .then(response => {
          if (response.success) {
            this.gridInit(this.GetDataGrid(this.dxDataGridRef))
            this.datasource = response.list
            this.FocusFirstRow(this.GetDataGrid(this.dxDataGridRef))
          }
        })
        .catch(error => {
          console.error('btnserach error catch >> ', error)
        })
        .finally(() => {
          this.endLoading()
        })
    },
    // 저장 버튼
    async btnSave() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()

      //선택 여부 확인
      if (selectedRows.length < 1) {
        this.vToastify(this.$t('selectionData'), 'warn')
        this.GetDataGrid(this.dxDataGridRef).endUpdate()
        return
      }
      let criticalIndex = selectedRows.findIndex(
        element =>
          element.detailCd == null ||
          element.detailNm == null ||
          element.majorCd == null ||
          element.majorNm == null ||
          element.detailCd == '' ||
          element.detailNm == '' ||
          element.majorCd == '' ||
          element.majorNm == ''
      )

      if (criticalIndex >= 0) {
        this.vToastify(this.$t('필수항목 입력하세요.<br>[세세분류, 대분류]'), 'warn')
        this.GetDataGrid(this.dxDataGridRef).endUpdate()
        return
      }

      this.vToastifyPrompt(
        this.$t('doSaveData'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()

          this.openLoading('saving')

          saveTypes(selectedRows, true)
            .then(response => {
              if (response.success) {
                console.log('success save >> ', selectedRows)
              }
            })
            .catch(error => {
              console.error('btnsave error catch >> ', error)
            })
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
              this.btnSearch()
            })
        },
        null,
        true
      )
    },
    btnUpload() {
      const element = document.createElement('input')
      element.type = 'file'
      element.style.display = 'none'
      element.accept = '.csv'
      document.body.appendChild(element)

      element.click()

      element.addEventListener('change', event => {
        if (event.target.files[0].type !== 'text/csv') {
          this.vToastify(this.$t('csv 파일만 업로드 가능합니다.'), 'warn')
          return
        }

        this.vToastifyPrompt(
          this.$t(`업로드하시겠습니까?</br>${event.target.files[0].name}`),
          'info',
          current => {
            this.openLoading()
            this.datasource = []
            const file = event.target.files[0]
            const formData = new FormData()
            formData.append('file', file)

            uploadForms(formData, true)
              .then(response => {
                if (response.success) {
                  this.GetDataGrid(this.dxDataGridRef).beginUpdate()

                  for (let i = 0; i < response.list.length; i++) {
                    let data = response.list[i]
                    data.id = this.datasource.length + 1
                    this.GetDataGrid(this.dxDataGridRef).newRow(data)
                    this.GetDataGrid(this.dxDataGridRef).selectRows(data.id, true)
                  }

                  this.GetDataGrid(this.dxDataGridRef).endUpdate()
                }
              })
              .catch(error => {
                console.error('btnupload error catch >> ', error)
              })
              .finally(() => {
                this.endLoading()
              })
          },
          null,
          true
        )
      })
    },
    btnDownload() {
      this.vToastifyPrompt(
        this.$t('양식을 다운로드하시겠습니까?'),
        'info',
        current => {
          this.openLoading()

          getTypeForm()
            .then(response => {
              if (response) {
                let params = {
                  clntId: response.clntId,
                  writeDt: response.writeDt,
                  docNo: response.docNo
                }
                downloadFile(params).then(file => {
                  let link = document.createElement('a')
                  let objectUrl = window.URL.createObjectURL(file)
                  link.href = objectUrl
                  link.download = response.fileDesc
                  link.click()
                })
              } else {
                this.vToastify(this.$t('다운로드 받을 수 있는 양식이 없습니다.'), 'warn')
                return
              }
            })
            .catch(error => {
              console.error('btndownload error catch >> ', error)
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    async btnPrint(type) {
      if (type == 'xls') {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet('업종코드')

        exportExcel({
          component: this.GetDataGrid(this.dxDataGridRef),
          worksheet,
          autoFilterEnabled: true
        }).then(() => {
          workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), '업종코드.xlsx')
          })
        })
      }

      if (type == 'pdf') {
        const doc = new jsPDF()
        doc.addFont(malgun, 'malgun', 'normal')

        exportPdf({
          jsPDFDocument: doc,
          component: this.GetDataGrid(this.dxDataGridRef),
          autoTableOptions: {
            styles: {
              font: 'malgun'
            }
          }
        }).then(() => {
          doc.save('업종코드.pdf')
        })
      }
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    //데이터 수정 시 로우 선택되도록
    onEditorPreparing(e) {
      if (e.parentType == 'dataRow') {
        var valueChanged = this.onCellValueChanged
        e.editorOptions.onValueChanged = args => {
          if (e.index > -1) {
            valueChanged(args.value, e)
          }
        }
      }
    },
    onCellValueChanged(value, cellInfo) {
      cellInfo.setValue(value)
      this.GetDataGrid(this.dxDataGridRef).selectRows(cellInfo.row.key, true)
    }
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
  }
}
</script>
